class InviewThings {
    constructor($el = ".js-inview-item", conf = { style: {} }) {
        const self = this;
        if (!$el) return;
        self.$el = typeof $el == "string" ? document.querySelectorAll($el) : $el;
        self.style = {
            from: conf.from ? conf.from : { opacity: "0", translate: "0 32px" },
            to: conf.to ? conf.to : false,
            transition: conf.transition ? conf.transition : "0.5s opacity ease,0.5s translate ease",
        };
        self.offset = { bottom: 20 };
        self.indexTimeout = conf.indexTimeout ? conf.indexTimeout : 60;
        self.inviewDelay = 400;
        self.count = 0;
        return self.init();
    }
    init() {
        const self = this;
        inView.offset(self.offset);
        self.$el.forEach(($row) => {
            if ($row.classList.contains("viewed")) return;
            Object.entries(self.style.from).forEach(([key, value]) => ($row.style[key] = value));
        });
        self.renderListHandler = self.renderList.bind(self);
        window.addEventListener("scroll", self.renderListHandler);
        setTimeout(() => self.renderList(), self.inviewDelay);
        return self;
    }
    renderList() {
        const self = this;
        let _t = self.inviewDelay;
        const elLength = self.$el.length;
        self.$el.forEach($row => {
            if ($row.classList.contains("viewed")) return;
            if (!inView.is($row)) return;
            $row.classList.add("viewed");
            setTimeout(() => {
                $row.transformEnd = e => {
                    e.target.style.transition = null;
                    e.target.removeEventListener("transitionend", e.target.transformEnd);
                }
                $row.addEventListener("transitionend", $row.transformEnd);
                $row.style.transition = self.style.transition;
                if (!self.style.to) {
                    for (const [key, value] of Object.entries(self.style.from)) if(key != "transition") $row.style[key] = null;
                } else Object.entries(self.style.to).forEach(([key, val]) => ($row.style[key] = val));
            }, _t);
            _t += self.indexTimeout;
            ++self.count === elLength && self.destroy();
        });
    }
    destroy() {
        window.removeEventListener("scroll", this.renderListHandler);
    }
}
const fsScrollTo = e => {
    e && e.preventDefault();
    const btn = e.target.closest(".scroll-to");
    const target = document.querySelector(btn.dataset.target);
    window.scrollTo({
        top: target.getBoundingClientRect().top + window.scrollY - (window.innerWidth > 1024 ? 64 : 60),
        behavior: "smooth",
    });
};
const fsPopup = e => {
    e && e.preventDefault();
    const btn = e.target.closest(".camp-popup__btn");
    const target = document.querySelector(btn.dataset.target);
    target.querySelector(".camp-popup__main").scrollTop = 0;
    target.classList.add("_active");
    document.body.style.overflow = "hidden";
};
const fsPopupClose = e => {
    e && e.preventDefault();
    const holder = e.target.closest(".camp-popup");
    holder.classList.remove("_active");
    document.body.style.overflow = "";
};
const fsPopupLargeClose = e => {
    e && e.preventDefault();
    !e.target.closest(".camp-popup__main") && fsPopupClose(e);
};
const fsSpecImgWidth = () => {
    if (window.width <= 991) return;
    const holders = document.querySelectorAll(".camp-bundle__container");
    const bodyWidth = document.body.getClientRects()[0].width;
    holders.forEach(holder => {
        const isRervers = holder.classList.contains("_reverse");
        const imgHolder = holder.querySelector(".camp-bundle__img");
        imgHolder.style.width = bodyWidth / 2 + "px";
        imgHolder.style[isRervers ? "margin-left" : "margin-right"] =
            ((bodyWidth - 1100) / 2) * (bodyWidth - 1100 < 0 ? 1 : -1) + "px";
    });
};
function fsCamp1Bg() {
    const el = document.querySelector(".camp-1__bg");
    const bgHeight = document.getElementById("camp-1").getBoundingClientRect().height - document.getElementById("camp-2").getBoundingClientRect().height
    el.style.height = bgHeight + "px";
}
const fsResize = () => {
    fsSpecImgWidth();
    fsCamp1Bg();
};
const fsInit = () => {
    document.querySelectorAll(".scroll-to").forEach(el => el.addEventListener("click", fsScrollTo));
    document.querySelectorAll(".camp-popup__btn").forEach(el => el.addEventListener("click", fsPopup));
    document.querySelectorAll(".camp-popup__close").forEach(el => el.addEventListener("click", fsPopupClose));
    document.querySelectorAll(".camp-popup").forEach(el => el.addEventListener("click", fsPopupLargeClose));
    new InviewThings(".js-inview-item", {
        indexTimeout: 200
    });
    fsResize();
};
window.addEventListener("resize", fsResize);
if (document.readyState === "complete" || document.readyState === "interactive") fsInit();
else document.addEventListener("DOMContentLoaded", fsInit);